import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reduxForm, Form, Field } from 'redux-form';

import { handleAddressChange } from 'checkout/checkout/common/helpers';
import AddressForm from 'common/components/address/AddressForm';
import {
  transformAddressData,
  initialFormValues
} from 'common/components/address/helpers';
import { RadioButton } from 'common/components/forms';
import { FormError } from 'common/components/layout';
import { getDefaultCountryCode } from 'common/helpers/miscHelper';
import { convertStringToInteger } from 'common/helpers/numberHelper';
import { updateClubSignup } from 'redux/clubSignup/actions';
import { listCustomerAddresses } from 'redux/customerAddresses/actions';

import AddressPicker from './components/AddressPicker';
import { validateAddressForLoggedInCustomer } from './validators';

class Billing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: 'shipping'
    };
  }

  componentDidMount() {
    const { props } = this;
    props.listCustomerAddresses();
  }

  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form, this.props);
    const clubSignup = {
      billTo: data,
      clubId: props.club.id
    };
    props.updateClubSignup(clubSignup);
  };

  handleAddressChange = (e) => {
    const { props } = this;
    const addressId = e.target.value;
    let address;
    if (addressId) {
      address = props.customerAddresses.data[addressId];
    }
    handleAddressChange(addressId, address, props.change, props.settings);
  };

  handleBack = (e) => {
    e.preventDefault();
    const { props } = this;
    props.onEdit('customer');
  };

  handleSameAsBilling = (e) => {
    this.setState({ selectedOption: e.currentTarget.value });
  };

  render() {
    const { clubSignup, handleSubmit, change, form } = this.props;
    const { customerAddresses, settings } = this.props;
    const { selectedOption } = this.state;
    let object = { countryCode: getDefaultCountryCode(settings) };
    if (clubSignup.shipTo) {
      object = clubSignup.shipTo;
    }
    return (
      <Form
        onSubmit={handleSubmit(this.handleSubmit)}
        className="c7-form"
        method="post"
      >
        <FormError formName={form} />
        <h3>Billing address</h3>
        <div className="c7-checkout__content__radio-options-group">
          <Field
            name="isSameAsBillingAddress"
            component={RadioButton}
            label="Same as shipping address"
            onChange={this.handleSameAsBilling}
            type="radio"
            value="shipping"
          />

          <Field
            name="isSameAsBillingAddress"
            component={RadioButton}
            label="Use a different billing address"
            onChange={this.handleSameAsBilling}
            type="radio"
            value="billing"
          />

          <div
            className="c7-checkout__content__radio-options-group__edit"
            style={{ display: selectedOption === 'shipping' && 'none' }}
          >
            <AddressPicker
              customerAddresses={customerAddresses.data}
              onAddressChange={this.handleAddressChange}
            />
            <AddressForm
              object={object}
              changeFunction={change}
              settings={settings}
            />
          </div>
        </div>

        <div className="c7-checkout__content__buttons">
          <button type="submit" className="c7-button">
            Continue to payment information
          </button>
          <a onClick={this.handleBack}>Return to customer information</a>
        </div>
      </Form>
    );
  }
}

const transformData = (values, props) => {
  let address;
  if (values.isSameAsBillingAddress === 'billing') {
    address = transformAddressData(values);
    address.customerAddressId = values.customerAddressId;
  } else {
    address = props.clubSignup.shipTo;
    delete address.id;
  }
  return address;
};

const validate = (values, props) => {
  let errors = {};
  if (values.isSameAsBillingAddress === 'billing') {
    const address = transformData(values, props);
    address.birthDay =
      values.birthDay && convertStringToInteger(values.birthDay);
    address.birthMonth =
      values.birthMonth && convertStringToInteger(values.birthMonth);
    address.birthYear =
      values.birthYear && convertStringToInteger(values.birthYear);
    errors = Object.assign(
      errors,
      validateAddressForLoggedInCustomer(address, props.settings)
    );
  }
  return errors;
};

const mapStateToProps = (state) => {
  let initialValues;
  if (state.clubSignup && state.clubSignup.data) {
    const { billTo } = state.clubSignup.data;
    initialValues = initialFormValues(billTo);
    initialValues.isSameAsBillingAddress = 'shipping';
  }
  return {
    customer: state.customer,
    settings: state.setting,
    customerAddresses: state.customerAddress,
    customerCreditCards: state.customerCreditCard,
    initialValues
  };
};

Billing = reduxForm({
  form: 'billingLoggedInShip',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(Billing);

export default withRouter(
  connect(mapStateToProps, {
    updateClubSignup,
    listCustomerAddresses
  })(Billing)
);
